import React, {
  Component,
  useState,
  useEffect,
  useRef,
  useContext,
} from "react";
import { ReactDOM } from "react-dom";
import "./ServiceRequestList.scss";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Button as Pbutton } from "primereact/button";
import { BsFillLockFill } from "react-icons/bs";
import { TabView, TabPanel } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import SelectBox from "../Select/Select.js";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import Sidenav from "../NavigationMenu/Sidenav";
import { TailSpin } from "react-loader-spinner";
import { Toast } from "primereact/toast";
import CloseButton from "react-bootstrap/CloseButton";
import { AuthContext } from "../../providers/AuthProvider.js";
import { Paginator } from "primereact/paginator";
import { Ripple } from "primereact/ripple";
import { classNames } from "primereact/utils";
import moment from "moment";
import { InputText } from "primereact/inputtext";
import check from "../../assets/captain.svg";
import { Tooltip } from "primereact/tooltip";
import { AsyncPaginate } from "react-select-async-paginate";
import { Spinner } from "react-bootstrap";
import { Checkbox } from "primereact/checkbox";
import {
  useQuery,
  gql,
  useLazyQuery,
  ApolloProvider,
  useMutation,
} from "@apollo/client";
import { client } from "../../services/GraphqlService";
import { Vessel_query, equipment_query } from "./vesselQuery";
import { Link } from "react-router-dom";
import {
  FaInfoCircle,
  FaExclamationTriangle,
  FaCalendarAlt, FaFileInvoiceDollar,
  FaShip,
  FaIdCard,
  FaPaperPlane,
  FaNetworkWired, FaCommentDots
} from "react-icons/fa";
import {
  getUserDetails,
  saveUserDetails,
} from "../UserSettings/UserSettingsSevice";
import { confirmDialog } from "primereact/confirmdialog";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
  useIsAuthenticated,
} from "@azure/msal-react";
import { validate } from "graphql";

const Customer_query = gql`
  query {
    customersByUser {
      userId
      customers {
        customerDisplayName
        customerName
        customerId
      }
    }
  }
`;
const Vessels_query = gql`
  query vesselsByUser($page: Int!, $pageSize: Int!, $search: String!) {
    vesselsByUser(page: $page, pageSize: $pageSize, search: $search) {
      items {
        id
        name
        yardNumber
        displayName
        maxRemoteAccessDuration
      }
      page
      pageSize
      totalCount
    }
  }
`;

const Customers_query = gql`
  query customersByUserAndVessel($vesselId: ID!) {
    customersByUserAndVessel(vesselId: $vesselId) {
      customerId
      customerName
      customerDisplayName
      isApproverDefined
    }
  }
`;
const Category_query = gql`
  query {
    serviceRecordTypes {
      name
      description
      code
    }
  }
`;

const ADD_NEW_REQUEST = gql`
  mutation upsertServiceRecord(
    $vesselId: Int!
    $custId: Int!
    $serviceRecordInput: ServiceRecordInput!
  ) {
    upsertServiceRecord(
      vesselId: $vesselId
      custId: $custId
      serviceRecordInput: $serviceRecordInput
    )
  }
`;

const UPDATE_REMOTE_ACCESS_SESSION = gql`
  mutation updateRemoteAccessSession(
    $vesselId: Int!
    $customerId: Int!
    $remoteAccessSessionActionInput: RemoteAccessSessionActionInput!
  ) {
    updateRemoteAccessSession(
      vesselId: $vesselId
      customerId: $customerId
      remoteAccessSessionActionInput: $remoteAccessSessionActionInput
    )
  }
`;

const ServiceRequestList = (props) => {
  let history = useNavigate();
  const [phoneMissing, setPhoneMissing] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [showBillingCustomer, setShowBillingCustomer] = useState(false);
  const { instance } = useMsal();
  const [busy, setBusy] = useState(false);
  const toast = useRef(null);
  const [isApprover, setIsApprover] = useState(true);
  const modalWindow = useRef(null);
  const calStartRef = useRef(null);
  const calEndRef = useRef(null);
  const [cId, setCustomerData] = useState("");
  const [vId, setVesselId] = useState(null);
  const [show, setShow] = useState(false);
  const [navigateToSettings, setNavigateToSettings] = useState(false);
  const [showSubmitProgress, setProgress] = useState(false);
  const [customerList, getCustomersList] = useState([]);
  const [vesselsList, setVesselDetails] = useState([]);
  const [customerListForMapping, getCustomersListMapping] = useState([]);
  const [equipmentList, setEquipmentList] = useState([]);
  const [titleValue, setTitleValue] = useState("");
  const [commentValue, setCommentValue] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [selectedVessel, setSelectedVessel] = useState({});
  const [serviceRecordList, setServiceRecords] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [hideArrow, setArrowHide] = useState(false);
  const [authorised, setAuthorisation] = useState(true);
  const [date, setDate] = useState("");
  const [dateStart, setDateStart] = useState();
  const [dateEnd, setDateEnd] = useState();
  const [maxEndDate, setMaxEndDate] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [endDateError, setEndDateError] = useState("");
  const [workReportedComments, setWorkReportedComments] = useState("");
  const [isWarranty, setIsWarranty] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [originalData, setOriginalData] = useState(null);
  const [hasChanges, setHasChanges] = useState(false);
  const handleClose = () => {
    setShow(false);
  }
  const handleDetailClose = () => {
    updateRemoteAccessSession({
      variables: {
        vesselId: detailVesselId,
        customerId: detailCustomerId,
        remoteAccessSessionActionInput: {
          requestId: detailRequestId,
          workflowCode: "REPORT_WORK",
          statusCode: "COMPLETED",
          comments: workDetailsText,
        },
      },
    });
    setDetail(false);
    setWorkDetailsText("");
    setReportWorkExpanded(true);
    setIsEditMode(false);
    setEditingRecord(null);
  };
  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(10);
  const [paginationOption, setpaginationOption] = useState([]);
  const [checkFields, setValidationCheck] = useState(false);
  const [details, setDetail] = useState(false);
  const [requestNumber, setRequestNumber] = useState("");
  const [currentWorkFlow, setCurrentWorkFlow] = useState("");
  const [newWorkFlow, setNewWorkFlow] = useState("");
  const [assigneeRole, setAssigneeRole] = useState("");
  const [detailTitle, setDetailTitle] = useState("");
  const [detailDateStart, setDetailDateStart] = useState("");
  const [detailDateEnd, setDetailDateEnd] = useState("");
  const [detailEquipment, setDetailEquipment] = useState("");
  const [detailVessel, setDetailVessel] = useState("");
  const [detailYardNumber, setDetailYardNumber] = useState("");
  const [reportWorkExpanded, setReportWorkExpanded] = useState(false);
  const [workDetailsText, setWorkDetailsText] = useState("");
  const [revokeWorkDetailsText, setRevokeWorkDetailsText] = useState("");
  const [selectedEquipment, setSelectedEquipment] = useState();
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(null);
  const [options, setOptions] = useState([]);
  const [startPage, setPage] = useState(1);
  const [itemsPerPage, setPageSize] = useState(50);
  const [searchParam, setSearchText] = useState("");
  const [totalVessels, setTotalVesselCount] = useState(0);
  const [additional, setAdditional] = useState({ page: 1 });
  const [inputValue, setInputValue] = useState("");
  const [detailRequestId, setDetailRequestId] = useState(null);
  const [detailVesselId, setDetailVesselId] = useState(null);
  const [detailCustomerId, setDetailCustomerId] = useState(null);
  const [detailIsRevoked, setDetailIsRevoked] = useState(false);
  const [detailIsWorkReported, setDetailIsWorkReported] = useState(false);
  const [isWithinAccessWindow, setIsWithinAccessWindow] = useState(false);
  const validateForm = () => {
    let errors = {};

    if (!titleValue.trim()) {
      errors.description = "Description is required";
    }

    if (!selectedCustomer.code) {
      errors.customer = "Customer is required";
    }

    if (!selectedVessel) {
      errors.vessel = "Vessel is required";
    }

    if (!dateStart) {
      errors.dateStart = "Start date is required";
    }

    if (!dateEnd) {
      errors.dateEnd = "End date is required";
    }
    if (!selectedEquipment || selectedEquipment.length === 0) {
      errors.equipment = "Equipment is required";
    } else if (selectedEquipment.length > 3) {
      errors.equipment = "Maximum 3 equipments can be selected";
    }

    if (dateStart && dateEnd) {
      var startTime = moment(dateStart, "DD-MM-YYYY hh:mm:ss");
      var endTime = moment(dateEnd, "DD-MM-YYYY hh:mm:ss");

      var minutesDiff = endTime.diff(startTime, "minutes");

      var secondsDiff = endTime.diff(startTime, "seconds");

      if (minutesDiff < 0 || secondsDiff < 0) {
        errors.dateStart = "Start date should not be after end date";
      }

      if (minutesDiff == 0 && secondsDiff == 0) {
        errors.dateEnd = "Start Date and End Date cannot be same";
      }
    }

    setErrors(errors);
    if (
      titleValue &&
      selectedVessel.value &&
      selectedCustomer.code &&
      dateStart &&
      dateEnd &&
      dateEnd > dateStart &&
      !errors.dateStart &&
      !errors.dateEnd &&
      !errors.equipment
    ) {
      submitDetails();
    }
    return Object.keys(errors).length === 0;
  };
  const handleEdit = async (record) => {
    setIsEditMode(true);
 
    setErrors({});
    setEditingRecord(record);
    const originalValues = {
      title: record.title || "",
      description: record.description || "",
      isWarrantyEnabled: record.isWarrantyEnabled || false,
      estimateStartDate: Number(record.estimateStartDate),
      estimateEndDate: Number(record.estimateEndDate),
    };

    setOriginalData(originalValues);
    setShow(true);
    // Description
    setTitleValue(record.title || "");
    // Comments
    setCommentValue(record.description || "");
    // Warranty
    const { status, data: result } = await getUserDetails();
    setUserDetails(result);
    setIsWarranty(record.isWarrantyEnabled || false);
    // Vessel
    const vesselObj = {
      value: record.vesselId,
      label: record.vessel,
      maxRemoteAccessDuration: record?.maxRemoteAccessDuration ?  record.maxRemoteAccessDuration : 12,
    };
    setSelectedVessel(vesselObj);

    // Customer
    const customerObj = {
      code: record.customerId,
      name: record.customer,
    };
    setSelectedCustomer(customerObj);

    // Populate customer dropdown
    getCustomersList([customerObj]);

    // Equipment
    const equipmentObj = [{
      id: record.equipmentId, // use actual field if available
      name: record.equipment
    }];

    setEquipmentList(equipmentObj);
    setSelectedEquipment(equipmentObj);
    const start = new Date(Number(record.estimateStartDate));
    const end = new Date(Number(record.estimateEndDate));
    setDateStart(start);
    setDateEnd(end);
    setMaxEndDate(end);
  };
  const showToaster = () => {
    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Request Submitted Successfully",
      life: 6000,
    });
  };

  const showDateTime = () => {
    toast.current.show({
      severity: "warn",
      summary: "Warn Message",
      detail: "Desired Start Time Should greater than Desired End Date",
      life: 5000,
    });
  };

  const onPageChange = (event) => {
    setFirst(1);
    setRows(event.rows);
    if (isDisabled) {
      getServiceRecords();
    }
  };

  const Service_query = gql`
  query {
    serviceRecordList (pageNumber:${first},pageSize:${rows}) {
      requestId,
      serviceRequestTypeCode,
      title,
      comments,
      createdDate,
      status,
      estimateStartDate,
      estimateEndDate,
      customer,
      customerId,
      vessel,
      maxRemoteAccessDuration,
      currentAssigneeJob,
      currentWorkFlow,
      nextWorkFlow,
      requestStatus,
      equipment,
      isApproverDefined,
      yardNumber,
      vesselId,
      isRevoked,
      configureStatus,
      deviceBehindSm,
      isWarrantyEnabled,
      description,
      denyReason,
      revokeAccessDetails {
        comments,
        assignedDate,
        createdUser,
        createdUserId
      }
    }
  }
`;
  useEffect(() => {
    if (!isEditMode || !originalData) {
      setHasChanges(false);
      return;
    }

    const changed =
      titleValue !== originalData.title ||
      commentValue !== originalData.description ||
      isWarranty !== originalData.isWarrantyEnabled ||
      moment(dateStart).valueOf() !== originalData.estimateStartDate ||
      moment(dateEnd).valueOf() !== originalData.estimateEndDate;

    setHasChanges(changed);
  }, [
    titleValue,
    commentValue,
    isWarranty,
    dateStart,
    dateEnd,
    originalData,
    isEditMode,
  ]);
  useEffect(() => { }, [vesselsList]);
  useEffect(() => {
    setFirst(1);
    setRows(10);
    getServiceRecords();
    cancelAction();
    setDate("");
    setCustomerData("");
  }, []);

  let today = new Date();
  let minDate = new Date();
  let month = today.getMonth();
  let year = today.getFullYear();
  let hour = today.getHours();
  let prevMonth = month === 0 ? 11 : month - 1;
  let prevYear = prevMonth === 11 ? year - 1 : year;
  minDate.setMonth(prevMonth);
  minDate.setFullYear(prevYear);
  minDate.setHours(hour + 2);

  const showToasterFailure = () => {
    toast.current.show({
      severity: "error",
      summary: "Error",
      detail: "Request Submission Failed",
      life: 5000,
    });
  };

  const showToasterFailureMessage = (errorMessage) => {
    toast.current.show({
      severity: "error",
      summary: "Error",
      detail: errorMessage,
      life: 5000,
    });
  };

  const template = {
    layout: "PrevPageLink PageLinks NextPageLink RowsPerPageDropdown",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 30, value: 30 },
      ];

      return (
        <Dropdown
          value={options.value}
          options={dropdownOptions}
          onChange={options.onChange}
          placeholder={dropdownOptions[0].label}
        />
      );
    },
  };

  // Tag-based ConfirmDialog approach
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [pendingCredits, setPendingCredits] = useState(0);

  const submitDetails = () => {
    // Calculate credits (replace with actual logic if needed)
    const credits = calculateCredits();
    setPendingCredits(credits);
    handleAddNewRequest();
    // setConfirmVisible(true);
  };

  const accept = () => {
    setConfirmVisible(false);
    handleAddNewRequest();
  };

  const reject = () => {
    setConfirmVisible(false);
    setProgress(false);
    setIsDisabled(false);
  };

  // Helper to calculate credits (stub, replace with real logic)
  const calculateCredits = () => {
    // Example: always 10 credits, update as needed
    return 10;
  };

  // Actual mutation call
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const handleAddNewRequest = async () => {
    setProgress(true);
    setIsDisabled(true);

    try {
      await Promise.all(
        selectedEquipment.map((equipment, index) =>
          delay(index * 500).then(() => {
            const formdetails = {
              serviceTypeCode: "RAR",
              title: titleValue,
              description: commentValue,
              requestId: 0,
              workflowCode: "ACCESS_REQUEST_RAISED",
              statusCode: "COMPLETED",
              estimateStartDate: moment(dateStart).utc().valueOf(),
              estimateEndDate: moment(dateEnd).utc().valueOf(),
              assignToRole: "CPN",
              assignToUser: null,
              equipmentId: parseInt(equipment.id),
              isWarrantyEnabled: isWarranty
            };

            const editedRecord = {
              workflowCode: "ACCESS_REQUEST_RAISED",
              serviceTypeCode: "RAR",
              title: titleValue,
              assignToRole: "CPN",
              description: commentValue,
              estimateStartDate: moment(dateStart).utc().valueOf(),
              estimateEndDate: moment(dateEnd).utc().valueOf(),
              isWarrantyEnabled: isWarranty,
              requestId: editingRecord ? editingRecord.requestId : 0
            }
            return addNewRequest({
              variables: {
                vesselId: selectedVessel.value,
                custId: selectedCustomer.code,
                serviceRecordInput: isEditMode ? editedRecord : formdetails,
              },
            });
          })
        )
      );
    } catch (error) {
      console.error(error);
    } finally {
      setProgress(false);
      setIsDisabled(false);
      setIsWarranty(false);
    }
  };
  const cancelAction = () => {
    setDateStart();
    setDateEnd();
    setMaxEndDate();
    setTitleValue("");
    setCommentValue("");
    setSelectedCustomer({});
    setSelectedVessel("");
    setDate("");
    handleClose();
    setProgress(false);
    setShow(false);
    setIsDisabled(false);
    setErrors({});
    setCustomerData("");
    setSelectedEquipment("");
    setEquipmentList([]);
    setStartDateError("");
    setEndDateError("");
    setVesselDetails([]);
    setTotalVesselCount(0);
    setIsWarranty(false);
    setIsEditMode(false);
    setEditingRecord(null);
  };

  const userLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  const goToServiceDetails = () => {
    history(`/serviceDetails`);
  };

  const goToReportWork = () => {
    history(`/serviceRequestForm`);
  };

  const goToClosedTicket = () => {
    history(`/serviceDetailsResolved`);
  };

  const shouldRedirectToSettings = async () => {
    try {
      const { status, data: result } = await getUserDetails();
      setUserDetails(result);
      setBusy(false);
      if (status === 204) {
        setPhoneMissing(true);
        return true;
      }
      // handle both server shapes: PhoneNumber vs phoneNumber
      const phone = String(result?.PhoneNumber ?? "").trim();
      // Redirect when phone is missing/empty
      if (phone.length === 0) {
        setPhoneMissing(true);
        return true;
      }
      return false;
    } catch (err) {
      setBusy(false);
      console.error("Failed to fetch user details:", err);
      // On error, you may choose not to redirect. Returning false keeps user on the page.
      return false;
    }
  };

  useEffect(() => {
    if (!navigateToSettings) return; // <-- do nothing until the flag is true
    //setBusy(true)
    // Optional: show toast before navigating
    setPhoneMissing(true);
    // toast.current.show({
    //   severity: "info",
    //   summary: "Information",
    //   detail: "Please add phone number in User Settings to continue.",
    //   life: 5000,
    // });

    // navigate("/userSettings", { replace: true });

    // Reset the flag
    setNavigateToSettings(false);
  }, [navigateToSettings, navigate]);

  const openRemoteAccessForm = async () => {
    cancelAction();
    setBusy(true);
    const redirectToSettings = await shouldRedirectToSettings();
    if (redirectToSettings) {
      setNavigateToSettings(true); // trigger the redirect & toast in useEffect
      return; // don't open the form
    }

    setShow(true);
    setIsDisabled(false);
    setVesselDetails([]);
    setPage(1);
    setIsApprover(true);
    setIsWarranty(false);
  };

  const getTimestamp = (timestamp) => {
    let d = timestamp / 1000;
    return moment.unix(d).format("DD-MM-YYYY");
  };

  const getDateFormat = (date) => {
    return moment.utc(date).local().format("DD-MM-YYYY HH:mm:ss a");
  };

  const [getCustomers, { loading, error, data }] = useLazyQuery(
    Customer_query,
    {
      fetchPolicy: "network-only",
      onCompleted(resp) {
        if (resp && resp.customersByUser.customers) {
          let modifiedList = [];
          resp.customersByUser.customers.map((cust) => {
            modifiedList.push({
              name:
                cust.customerDisplayName != null &&
                  cust.customerDisplayName.trim() != ""
                  ? cust.customerDisplayName
                  : cust.customerName,
              code: cust.customerId,
            });

            getCustomersList([...customerList, ...modifiedList]);
            getCustomersListMapping(modifiedList);
          });
        }
      },
      onError(err) {
        setAuthorisation(false);
      },
    },
  );

  // Function to call the query and get the result
  const fetchVesselsData = async (start, pages, search) => {
    let modifiedVesselList = [];
    try {
      const response = await getVesselData({
        variables: { page: start, pageSize: pages, search: search },
      });

      if (response.data) {
        setTotalVesselCount(response.data.vesselsByUser.totalCount);
        response.data.vesselsByUser.items.map((vessel) => {
          modifiedVesselList.push({
            label:
              vessel.displayName != null && vessel.displayName.trim() != ""
                ? vessel.displayName
                : vessel.name,
            value: vessel.id,
            maxRemoteAccessDuration:
              vessel.maxRemoteAccessDuration !== null
                ? vessel.maxRemoteAccessDuration
                : 12,
          });
        });
      }
      setVesselDetails([...vesselsList, ...modifiedVesselList]);
      return {
        data: modifiedVesselList,
        totalCount: response.data.vesselsByUser.totalCount,
      };
    } catch (err) {
      // handle error
      const errorMessage = "An error occurred while fetching vessels.";
      showToasterFailureMessage(errorMessage);
      return null;
    }
  };

  const [getVesselData, { }] = useLazyQuery(Vessels_query, {
    fetchPolicy: "network-only",
  });
  // const [getVesselLists, {}] = useLazyQuery(Vessels_query, {
  //   fetchPolicy: "network-only",
  //   onCompleted(resp) {
  //     if (resp && resp.vesselsByUser) {
  //       setTotalVesselCount(resp.vesselsByUser.totalCount);
  //       let modifiedVesselList = [];
  //       if (resp.vesselsByUser.items.length > 0) {
  //         resp.vesselsByUser.items.map((vessel) => {
  //           modifiedVesselList.push({
  //             label:
  //               vessel.displayName != null && vessel.displayName.trim() != ""
  //                 ? vessel.displayName
  //                 : vessel.name,
  //             value: vessel.id,
  //             maxRemoteAccessDuration:
  //               vessel.maxRemoteAccessDuration !== null
  //                 ? vessel.maxRemoteAccessDuration
  //                 : 12,
  //           });
  //         });
  //         setVesselDetails(modifiedVesselList);
  //       }
  //     }
  //   },
  //   onError(err) {
  //     setAuthorisation(false);
  //   },
  // });
  const [getCustomerLists, { }] = useLazyQuery(Customers_query, {
    fetchPolicy: "network-only",
    onCompleted(resp) {
      if (resp && resp.customersByUserAndVessel) {
        let modifiedList = [];
        resp.customersByUserAndVessel.map((cust) => {
          modifiedList.push({
            name:
              cust.customerDisplayName != null &&
                cust.customerDisplayName.trim() != ""
                ? cust.customerDisplayName
                : cust.customerName,
            code: cust.customerId,
            isApproverDefined: cust.isApproverDefined,
          });

          getCustomersList(modifiedList);
        });
        if (modifiedList.length == 1) {
          setSelectedCustomer(modifiedList[0]);
          if (modifiedList[0].isApproverDefined) {
            setIsApprover(true);
          } else {
            setIsApprover(false);
          }
          setArrowHide(true);
          if (errors.customer) {
            errors.customer = "";
          }
        } else {
          setSelectedCustomer({});
          setArrowHide(false);
        }
      }
    },
    onError(err) {
      setAuthorisation(false);
    },
  });

  const [
    getEquipmentsList,
    { loading: equipLoading, error: equipError, data: equipmentData },
  ] = useLazyQuery(equipment_query, {
    fetchPolicy: "cache-and-network",
    onCompleted(resp) {
      setEquipmentList(resp.getEquipmentsByVessel);
    },
    onError(err) {
      setEquipmentList([]);
    },
  });

  const [
    getServiceRecords,
    { loading: serviceloading, error: servicerror, data: serviceRecord },
  ] = useLazyQuery(Service_query, {
    fetchPolicy: "network-only",
    onCompleted(resp) {
      if (resp.serviceRecordList) {
        setServiceRecords(resp.serviceRecordList);
      }
    },
  });

  const [updateRemoteAccessSession] = useMutation(
    UPDATE_REMOTE_ACCESS_SESSION,
    {
      fetchPolicy: "network-only",
      onCompleted(resp) {
        if (resp.updateRemoteAccessSession === "Success") {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Work report submitted successfully",
            life: 4000,
          });
          getServiceRecords();
        } else {
          showToasterFailureMessage("Failed to update remote access session");
        }
      },
      onError(err) {
        const errorMessage = err?.message || "An unexpected error occurred";
        showToasterFailureMessage(errorMessage);
      },
    },
  );

  const [
    addNewRequest,
    {
      loading: newrequestloading,
      error: newrequesterror,
      data: newrequestdata,
    },
  ] = useMutation(ADD_NEW_REQUEST, {
    fetchPolicy: "network-only",
    onCompleted(resp) {
      if (resp.upsertServiceRecord.status === "Success") {
        showToaster();
        handleClose();
        setIsDisabled(false);
        setIsWarranty(false);
        setErrors({});
        getServiceRecords();
        setIsEditMode(false)
      } else {
        showToasterFailure();
        cancelAction();
      }
    },
    onError(err) {
      const errorMessage = err?.message || "An unexpected error occurred";
      showToasterFailureMessage(errorMessage);
      cancelAction();
      getServiceRecords();
    },
  });

  const handleStartDateChange = (e) => {
    let selectedStartDate = e.value;
    setDateStart(selectedStartDate);
    if (
      selectedStartDate &&
      selectedVessel &&
      selectedVessel.maxRemoteAccessDuration
    ) {
      let calculatedEndDate = new Date(
        selectedStartDate.getTime() +
        selectedVessel.maxRemoteAccessDuration * 60 * 60 * 1000,
      );
      setDateEnd(calculatedEndDate);
      setMaxEndDate(calculatedEndDate);
      if (errors.dateStart) {
        errors.dateStart = "";
      }
      if (errors.dateEnd) {
        errors.dateEnd = "";
      }
    }
  };
  const updatEndDate = (e) => {
    if (dateStart && selectedVessel && selectedVessel.maxRemoteAccessDuration) {
      let calculatedEndDate = new Date(
        dateStart.getTime() +
        selectedVessel.maxRemoteAccessDuration * 60 * 60 * 1000,
      );
      setMaxEndDate(calculatedEndDate);
      if (errors.dateEnd) {
        errors.dateEnd = "";
      }
    }
    setTimeout(() => {
      setDateEnd(e.value);
    });
  };

  const handleStartTimeInputChange = (e) => {
    if (!dateStart || !e.target.value) return;
    const [h, m, s = 0] = e.target.value.split(":").map(Number);
    const updated = new Date(dateStart);
    updated.setHours(h, m, s);
    if (updated <= new Date()) {
      setStartDateError("Start time cannot be in the past");
    }
    else {
      setStartDateError("");
    }
    handleStartDateChange({ value: updated });
  };

  const handleEndTimeInputChange = (e) => {
    if (!dateEnd || !e.target.value) return;
    const [h, m, s = 0] = e.target.value.split(":").map(Number);
    const updated = new Date(dateEnd);
    updated.setHours(h, m, s);
    if (maxEndDate && updated > maxEndDate) {
      setEndDateError(`The selected end time exceeds the maximum allowed time of <b style="font-weight: bold;">${maxEndDate.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false })}</b>. Please adjust the start or end time accordingly.`);
    }
    else if (dateStart && updated <= dateStart) {
      setEndDateError("End time cannot be before or equal to the start time");
    }
    else {
      setEndDateError("");
    }

    setDateEnd(updated);
  };

  const populateVessel = (event, errors) => {
    if (event.value.isApproverDefined) {
      setIsApprover(true);
    } else {
      setIsApprover(false);
    }
    setCustomerData(event.value);
    setSelectedCustomer(event.value);
    if (event.value !== "") {
      errors.customer = "";
    } else {
      errors.customer = "Customer is required";
    }
  };
  const setSelectedEquipments = (event, errors) => {
    setSelectedEquipment(event);
    if (event !== "") {
      errors.equipment = "";
    } else {
      errors.equipment = "Equipment is required";
    }
  };
  const handleEquipmentChange = (e) => {
    if (e.value.length > 3) {
      toast.current.show({
        severity: "warn",
        summary: "Maximum limit reached",
        detail: "Maximum 3 equipment(s) allowed.",
      });
      return;
    }

    setSelectedEquipment(e.value);
  };

  const getEquipments = (event) => {
    let vesselId = event.value ? event.value.code : event;
    getEquipmentsList({ variables: { vesselId: vesselId } });
  };

  const populateTitleValue = (event, errors) => {
    setTitleValue(event.target.value);
    if (event.target.value !== "") {
      errors.description = "";
    } else {
      errors.description = "Description is required";
    }
  };

  const populateCommentValue = (event) => {
    setCommentValue(event.target.value);
  };

  const populateDate = (event) => {
    setDate(event.value);
    setStartDate(event.value[0]);
    setEndDate(event.value[1]);

    if (event.value !== "") {
      errors.date = "";
    }

    if (event.value[0] == null && event.value[1] == null) {
      errors.date = "Date is required";
    }

    if (event.value[1] == null && event.value[0] !== null) {
      errors.date = "End Date is required";
    }

    if (event.value[0] && event.value[1]) {
      var startTime = moment(event.value[0], "DD-MM-YYYY hh:mm:ss");
      var endTime = moment(event.value[1], "DD-MM-YYYY hh:mm:ss");

      var minutesDiff = endTime.diff(startTime, "minutes");

      var secondsDiff = endTime.diff(startTime, "seconds");

      if (minutesDiff == 0 && secondsDiff == 0) {
        errors.date = "Start Date and End Date cannot be same";
      }

      if (startTime.diff(endTime) > 0) {
        showDateTime();
      }
    }
  };

  const showDetail = (record) => {
    if (record.currentAssigneeJob !== "Captain") {
      setDetail(true);
      let requestDetailNumber =
        record.serviceRequestTypeCode + "-" + record.requestId;
      setWorkReportedComments(record.comments);
      setRequestNumber(requestDetailNumber);
      setDetailTitle(record.title);
      setCurrentWorkFlow(record.currentWorkFlow);
      setNewWorkFlow(record.nextWorkFlow);
      setAssigneeRole(record.currentAssigneeJob);
      setDetailDateStart(getTimestamp(record.estimateStartDate));
      setDetailDateEnd(getTimestamp(record.estimateEndDate));
      setDetailEquipment(record.equipment);
      setDetailVessel(record.vessel);
      setDetailYardNumber(record.yardNumber);
      setDetailRequestId(record.requestId);
      setDetailVesselId(record.vesselId);
      setDetailCustomerId(record.customerId);
      setDetailIsRevoked(record.isRevoked || false);
      setDetailIsWorkReported(
        record.requestStatus === "Completed" && record.currentWorkFlow === "Report Work"
      );
      if (record.revokeAccessDetails) {
        setRevokeWorkDetailsText(`Access was revoked on ${getDateFormat(record.revokeAccessDetails.assignedDate)} by ${record.revokeAccessDetails.createdUser} with comments: ${record.revokeAccessDetails.comments}`);
      }
      const now = Date.now();
      setIsWithinAccessWindow(
        now >= record.estimateStartDate &&
        record.nextWorkFlow === "Report Work" &&
        (record.deviceBehindSm == true ||
          record.configureStatus == "User granted access to equipment"),
      );
      setWorkDetailsText("");
      // setReportWorkExpanded(true);
    }
  };

  const loadVessels = async (search, loadedOptions, { page }) => {
    let nextPage;
    let vessels = [];
    let pageNo;
    if (search.trim().length == 0) {
      pageNo = startPage;
    } else {
      pageNo = 1;
    }
    const updatedList = await fetchVesselsData(pageNo, itemsPerPage, search);
    if (updatedList) {
      vessels = loadedOptions.concat(updatedList.data);
      const options = updatedList.data.map((item) => ({
        label: item.name,
        value: item.id,
        maxRemoteAccessDuration: item.maxRemoteAccessDuration,
      }));

      await new Promise((resolve) => setTimeout(resolve, 500));
      nextPage = updatedList.totalCount > vessels.length ? startPage + 1 : 1;
      setPage(nextPage);

      if (!search && loadedOptions.length > 0 && page === 1) {
        return { options: [], hasMore: false, additional: { page } };
      }
      return {
        options: updatedList.data.map((item) => ({
          label: item.label,
          value: item.value,
          maxRemoteAccessDuration: item.maxRemoteAccessDuration,
        })),
        hasMore: loadedOptions.length + options.length < updatedList.totalCount,
        additional: { page: page + 1 },
      };
    } else {
      return {
        options: [],
        hasMore: false,
        additional: { page: 0 },
      };
    }
  };

  const setSelectedVesselData = (event, errors) => {
    setSelectedVessel(event);
    setSelectedCustomer({});
    setDateStart();
    setDateEnd();
    setStartDateError("");
    setEndDateError("");
    setMaxEndDate();
    setSelectedEquipment("");
    validationVesselCheck(event);
    setIsApprover(true);
    if (event != null) {
      getCustomerLists({ variables: { vesselId: event.value } });
      setVesselId(event.value);
      setInputValue(event.value);
      getEquipments(event.value);
    } else {
      setInputValue("");
    }
  };

  const validationVesselCheck = (e) => {
    if (e) {
      errors.vessel = "";
      // setIsApprover(e.isApproverDefined)
      getEquipments(e);
    } else {
      // setIsApprover(true);
      setSelectedCustomer({});
      setEquipmentList([]);
      getCustomersList([]);
      setSelectedEquipment("");
    }
  };

  const [bgColor, setBgColor] = useState("#224691");
  const footerContent = (
    <div>
      <div className="comment-button-group button-group">
        <Button variant="secondary close-form" onClick={cancelAction}>
          CANCEL
        </Button>
        {!showSubmitProgress ? (
          <Button
            variant="secondary submit-approval approve"
            onClick={validateForm}
            disabled={
              !!startDateError ||
              !!endDateError ||
              (isEditMode && !hasChanges)
            }
          >
            {isEditMode ? "UPDATE" : "SUBMIT"}
          </Button>
        ) : (
          <Pbutton
            label="Submit"
            icon="pi pi-spin pi-spinner"
            iconPos="right"
            className="submit-approval approve"
          />
        )}
      </div>
      {!isApprover ? (
        <div className="warning-msg">
          <span className="msgText">
            <li className="pi pi-exclamation-triangle"></li> &nbsp; No approver
            has been assigned to this vessel to approve the request.
          </span>
        </div>
      ) : null}
    </div>
  );

  return authorised ? (
    <div className="service-request-wrapper">
      <ConfirmDialog
        visible={confirmVisible}
        onHide={() => setConfirmVisible(false)}
        message={`This request would consume ${pendingCredits} credits, based on the tariff of 2 credits / hour. Would you like to proceed?`}
        header="Confirm Submission"
        icon="pi pi-exclamation-triangle"
        style={{ width: "390px", maxWidth: "90vw" }}
        accept={accept}
        reject={reject}
      />
      {serviceloading && (
        <div className="loader">
          <TailSpin
            color=" #2546B1"
            height={80}
            width={80}
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass="loader"
            visible={true}
          />
        </div>
      )}

      {busy /* || loading || equipLoading */ && (
        <div className="screen-loader-overlay">
          <TailSpin
            color="#2546B1"
            height={80}
            width={80}
            ariaLabel="tail-spin-loading"
            radius="1"
            visible={true}
          />
          {/* <div className="loader-text">Please wait…</div> */}
        </div>
      )}

      {phoneMissing && (
        <div className="phone-banner">
          <div className="phone-banner-icon">
            <i className="pi pi-exclamation-triangle"></i>
          </div>

          <div className="phone-banner-text">
            <div className="title">Phone number required</div>
            <div className="subtitle">
              Add your phone number in User Settings to continue.
            </div>
          </div>

          <button
            className="open-settings-btn"
            onClick={() => navigate("/userSettings")}
          >
            Open Settings
          </button>
        </div>
      )}

      {/* {phoneMissing && (
        <div className="inline-banner">
          <span>Phone number is mandatory. Please add it in User Settings to proceed.</span>
          <Button className="ml-2" onClick={() => navigate("/userSettings")}>
            Go to Settings
          </Button>
        </div>
      )} */}

      {!serviceloading && (
        <>
          <div className="header-wrapper">
            <div className="app-header">TRITON GUARD</div>
            <div className="service-request-header">SERVICE REQUESTS</div>
          </div>
          <Sidenav bgColor={bgColor}></Sidenav>
          <div
            className={
              "service-request-details-wrapper" + (busy ? " reduceOpacity" : "")
            }
          >
            <TabView>
              <TabPanel header="Raised">
                {serviceRecordList.length > 0 ? (
                  serviceRecordList.map((record, i) => (
                    <div className="service-details-summary" key={i}>
                      <div className="issue-details-wrapper remote-access">
                        <div className="issue-description remote-access">
                          <div className="record-description descrption-style">
                            {record.isWarrantyEnabled && (
                              <>
                                <Tooltip target={`.warranty-${i}`} />
                                <span
                                  className={`warranty-icon warranty-${i}`}
                                  data-pr-tooltip="Under Warranty"
                                >
                                  <i className="pi pi-shield"></i>
                                  <i className="pi pi-check"></i>
                                </span>
                              </>
                            )}
                            <Tooltip target={`.request-info-${i}`} position="top" />

                            <span
                              className={`request-info request-info-${i}`}
                              data-pr-tooltip={`${record.serviceRequestTypeCode} - ${record.requestId} - ${record.title}`}

                            >
                              {record.serviceRequestTypeCode} - {record.requestId} - {record.title}
                            </span>
                            <Tooltip target=".edit-icon" className="edit-tooltip"/>
                            {!(record.requestStatus === "Completed" &&
                              record.currentWorkFlow === "Request Approval") && !(record.requestStatus == "Completed" &&
                              record.currentWorkFlow == "Report Work") && !(record.isRevoked) && (<i
                                className="pi pi-pencil edit-icon" data-pr-tooltip="Edit Request" onClick={() => handleEdit(record)}
                              />)}
                          </div>
                          <div className="yard-no" title="Yard Number">
                            YN : {record.yardNumber}
                          </div>
                          <Tooltip target={".check" + i} event="both" />
                          {!record.isApproverDefined &&
                            record.currentWorkFlow == "Access Request Raised" ? (
                            <div>
                              <img
                                data-pr-tooltip="Approver not available"
                                data-pr-position="left"
                                alt="check"
                                className={"check" + i}
                                src={check}
                                style={{
                                  height: "27px",
                                  left: "-3%",
                                  float: "right",
                                  position: "relative",
                                }}
                              />
                            </div>
                          ) : null}
                          <div className="msgIcon"></div>
                        </div>
                        <Tooltip target=".equipment-name" className="equipment-name-tooltip"/>
                        <div className="equipment-name"  data-pr-tooltip={`${record.equipment}`}
                                data-pr-position="top" >{record.equipment}</div>
                        <div className="vessel-details remote-access-customer" title={`${record.customer} - ${record.vessel}`}>
                          {record.customer} - {record.vessel}
                        </div>
                        <div className="issue-timestamp remote-date">
                          {getTimestamp(record.estimateStartDate)}-{" "}
                          {getTimestamp(record.estimateEndDate)}
                        </div>
                        <div className="issue-status remote-status">
                          {record.currentWorkFlow == "Access Request Raised" &&
                            !record.isRevoked ? (
                            <span className="pending">
                              Pending with Approver
                            </span>
                          ) : (
                            <div>
                              {record.requestStatus == "Completed" &&
                                record.currentWorkFlow == "Request Approval" ? (
                                <>
                                  <span className="approved">
                                    Access Request Approved
                                  </span>
                                  <button
                                    className="details-dots-btn"
                                    onClick={() => showDetail(record)}
                                    title="View Details"
                                  >
                                    &#8226;&#8226;&#8226;
                                  </button>
                                </>
                              ) : record.requestStatus == "Completed" &&
                                record.currentWorkFlow == "Report Work" ? (
                                <>
                                  <span className="approved">
                                    Work Reported
                                  </span>
                                  <button
                                    className="details-dots-btn"
                                    onClick={() => showDetail(record)}
                                    title="View Details"
                                  >
                                    &#8226;&#8226;&#8226;
                                  </button>
                                </>
                              ) : record.isRevoked ? (
                                <>
                                  <span className="revoked">
                                    <i className="pi pi-exclamation-triangle"></i> Session Revoked
                                  </span>
                                  <button
                                    className="details-dots-btn"
                                    onClick={() => showDetail(record)}
                                    title="View Details"
                                  >
                                    &#8226;&#8226;&#8226;
                                  </button>
                                </>
                              ) : (
                                <>
                                  <span className="pending">
                                    Session Denied
                                  </span>
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-record">No Records Found</div>
                )}
              </TabPanel>
              <TabPanel header="Assigned" disabled>
                <div
                  className="service-details-summary"
                  onClick={() => goToServiceDetails()}
                >
                  <div className="vessel-image">
                    <div className="user-box">
                      <img
                        src="https://picsum.photos/200/300?random=1"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="issue-details-wrapper assigned">
                    <div className="vessel-details">Vessel 1-Customer 1</div>
                    <div className="issue-description">
                      Abnormal Sound from Engine
                    </div>
                    <div className="issue-timestamp">5th May 2022</div>
                    <div className="issue-status assigned-status">Pending</div>
                  </div>
                </div>
                <div
                  className="service-details-summary"
                  onClick={() => goToReportWork()}
                >
                  <div className="vessel-image">
                    <div className="user-box">
                      <img
                        src="https://picsum.photos/200/300?random=2"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="issue-details-wrapper assigned">
                    <div className="vessel-details">Vessel 2-Customer 2</div>
                    <div className="issue-description">
                      Maintenance Upgrade required
                    </div>
                    <div className="issue-timestamp">5th May 2022</div>
                    <div className="issue-status in-progress assigned-status">
                      Work in Progress
                    </div>
                  </div>
                </div>
                <div
                  className="service-details-summary"
                  onClick={() => goToClosedTicket()}
                >
                  <div className="vessel-image">
                    <div className="user-box">
                      <img
                        src="https://picsum.photos/200/300?random=3"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="issue-details-wrapper assigned">
                    <div className="vessel-details">Vessel 3-Customer 3</div>
                    <div className="issue-description">
                      Maintenance Upgrade required
                    </div>
                    <div className="issue-timestamp">5th May 2022</div>
                    <div className="issue-status resolved assigned-status">
                      Resolved
                    </div>
                  </div>
                </div>
              </TabPanel>
            </TabView>
          </div>
          <div className="service-request-remote-access">
            <div className="card">
              {serviceRecordList.length > 0 && (
                <Paginator
                  template={template}
                  first={first}
                  rows={rows}
                  totalRecords={serviceRecordList.length}
                  rowsPerPageOptions={[10, 20, 30]}
                  onPageChange={onPageChange}
                ></Paginator>
              )}
            </div>
            <Button
              className="request-access-button"
              onClick={() => openRemoteAccessForm()}
            >
              Request Access
            </Button>
          </div>
        </>
      )}

      <div className="access-form-modal-wrapper " ref={modalWindow}>
        {loading && (
          <div className="loader">
            <TailSpin color=" #2546B1" height={80} width={80} />
          </div>
        )}
        {
          <Dialog
            header={isEditMode ? "EDIT ACCESS REQUEST" : "NEW ACCESS REQUEST"}
            headerClassName="dialog-header"
            className="access-form-modal report access-modal service-request-wrapper dialog calemdar-body"
            visible={show}
            style={{ width: "50vw", background: "#0000004d" }}
            position="center"
            onHide={handleClose}
            footer={footerContent}
          >
            {editingRecord?.requestStatus == "Cancelled" && (
              <div className="cancellation-banner">
                <FaCommentDots className="banner-icon" />
                <div className="banner-content">
                  <span className="banner-title">Cancellation Reason : </span>
                  <span className="banner-text">
                    {editingRecord.denyReason}
                  </span>
                </div>
              </div>
            )}
            <label className="form-label report select-title vessel">
              Description
            </label>
            <br></br>
            <InputText
              value={titleValue}
              onChange={(e) => populateTitleValue(e, errors)}
              disabled={isDisabled}
              autoComplete="off"
              style={{ width: "100%" }}
              maxLength={150}
              className={"" + (errors.description ? "error-highlight" : "")}
            />
            {errors.description && (
              <span class="error-msg">{errors.description}</span>
            )}{" "}
            <br></br>
            <label className="form-label select-title vessel report label-size">
              Vessel
            </label>
            <AsyncPaginate
              value={selectedVessel}
              isDisabled={isEditMode}
              loadOptions={loadVessels}
              className="paginated-dropdown"
              loadingMessage={() => {
                <Spinner animation="border" size="sm" />;
              }}
              onChange={setSelectedVesselData}
              appendTo={document.querySelector(".calemdar-body")}
              isClearable={true}
              reduceOptions={(prevOptions, loadedOptions) => [
                ...prevOptions,
                ...loadedOptions,
              ]}
              debounceTimeout={500}
              placeholder="Select Vessel"
              defaultOptions={false}
              additional={{ page: 1 }}
            />
            {errors.vessel && (
              <span className="error-msg">{errors.vessel}</span>
            )}
            <br></br>
            <label className="form-label select-title vessel report label-size cust">
              Customer
            </label>
            <Dropdown
              value={selectedCustomer}
              onChange={(e) => populateVessel(e, errors)}
              options={customerList}
              optionLabel="name"
              appendTo={document.querySelector(".calemdar-body")}
              placeholder="Select Customer"
              disabled={isDisabled || isEditMode}
              className={classNames({
                "no-action": hideArrow,
                "no-arrow": hideArrow,
                "error-highlight": errors.customer,
              })}
              dropdownIcon={hideArrow ? null : "pi pi-chevron-down"}
            />
            {errors.customer && (
              <span className="error-msg">{errors.customer}</span>
            )}
            <label className="form-label select-title vessel report label-size">
              Equipment(s)
            </label>

            <MultiSelect
              value={selectedEquipment}
              options={equipmentList}
              optionLabel="name"
              showSelectAll={false}
              placeholder="Select Equipment"
              appendTo={document.querySelector(".calemdar-body")}
              disabled={isDisabled || isEditMode}
              display="chip"
              className={`equipment-multiselect ${errors.equipment ? "error-highlight" : ""
                }`}
              onChange={handleEquipmentChange}
            />
            {errors.equipment && (
              <span className="error-msg"> {errors.equipment}</span>
            )}
            <label className="form-label select-title report label-size">
              Access Date Start
            </label>
            <Calendar
              id="time24Start"
              ref={calStartRef}
              value={dateStart}
              onChange={handleStartDateChange}
              appendTo="self"
              baseZIndex={10000}
              showTime
              showSeconds
              disabled={
                isEditMode
                  ? false
                  : (!selectedCustomer?.code ||
                    !selectedVessel?.value ||
                    isDisabled)
              }
              minDate={today}
              readOnlyInput
              panelClassName="custom-time-panel"
              footerTemplate={() => (
                <div className="time-edit-footer">
                  <div className="time-edit-row">
                    <span className="time-edit-label">Time:</span>
                    <div className="time-input-trigger">
                      <span className="time-clock-icon">🕐</span>
                      <input
                        type="time"
                        id="appt-start"
                        name="appt-start"
                        className="time-edit-input"
                        lang="en-GB"
                        step="1"
                        min={
                          dateStart && dateStart.toDateString() === new Date().toDateString()
                            ? [new Date().getHours(), new Date().getMinutes(), new Date().getSeconds()]
                              .map((n) => String(n).padStart(2, "0"))
                              .join(":")
                            : undefined
                        }
                        value={
                          dateStart
                            ? [dateStart.getHours(), dateStart.getMinutes(), dateStart.getSeconds()]
                              .map((n) => String(n).padStart(2, "0"))
                              .join(":")
                            : ""
                        }
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                        onFocus={(e) => e.stopPropagation()}

                        onChange={handleStartTimeInputChange}
                      />
                    </div>
                  </div>
                  <button
                    className="cal-close-btn"
                    onClick={() => calStartRef.current.hide()}
                  >
                    Close
                  </button>
                </div>
              )}
              className={
                errors.dateStart
                  ? "error-highlight disableDate"
                  : !selectedCustomer || !selectedVessel
                    ? "disableDate"
                    : ""
              }
            />
            {errors.dateStart && (
              <span className="error-msg">{errors.dateStart}</span>
            )}
            {startDateError && (
              <span className="error-msg" style={{ marginLeft: "7px" }}>{startDateError}</span>
            )}
            <label className="form-label select-title report label-size">
              Access Date End
            </label>
            <Calendar
              id="time24End"
              ref={calEndRef}
              value={dateEnd}
              onChange={updatEndDate}
              appendTo="self"
              showTime
              showSeconds
              minDate={dateStart || today}
              maxDate={maxEndDate}
              readOnlyInput
              baseZIndex={10000}
              disabled={
                isEditMode
                  ? false
                  : (!selectedCustomer?.code ||
                    !selectedVessel?.value ||
                    !dateStart)
              }
              panelClassName="custom-time-panel"
              footerTemplate={() => (
                <div className="time-edit-footer">
                  <div className="time-edit-row">
                    <span className="time-edit-label">Time:</span>
                    <div className="time-input-trigger">
                      <span className="time-clock-icon">🕐</span>
                      <input
                        type="time"
                        id="appt-end"
                        name="appt-end"
                        className="time-edit-input"
                        lang="en-GB"
                        step="1"
                        min={
                          dateEnd && dateStart &&
                            dateEnd.toDateString() === dateStart.toDateString()
                            ? [dateStart.getHours(), dateStart.getMinutes(), dateStart.getSeconds()]
                              .map((n) => String(n).padStart(2, "0"))
                              .join(":")
                            : undefined
                        }
                        max={
                          dateEnd && maxEndDate &&
                            dateEnd.toDateString() === maxEndDate.toDateString()
                            ? [maxEndDate.getHours(), maxEndDate.getMinutes(), maxEndDate.getSeconds()]
                              .map((n) => String(n).padStart(2, "0"))
                              .join(":")
                            : undefined
                        }
                        value={
                          dateEnd
                            ? [dateEnd.getHours(), dateEnd.getMinutes(), dateEnd.getSeconds()]
                              .map((n) => String(n).padStart(2, "0"))
                              .join(":")
                            : ""
                        }
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                        onFocus={(e) => e.stopPropagation()}
                        onChange={handleEndTimeInputChange}
                      />
                    </div>
                  </div>
                  <button
                    className="cal-close-btn"
                    onClick={() => calEndRef.current.hide()}
                  >
                    Close
                  </button>
                </div>
              )}
              className={
                errors.dateEnd ? "error-highlight disableDate" : "disableDate"
              }
            />
            {errors.dateEnd && (
              <span className="error-msg">{errors.dateEnd}</span>
            )}
            {endDateError && (
              <span className="error-msg" style={{ marginLeft: "0px" }} dangerouslySetInnerHTML={{ __html: endDateError }} />
            )}
            <Form.Group
              className="mb-0 work-report-description"
              controlId="ControlTextarea"
            >
              <div className="comments-header">
                <Form.Label className="report label-size mb-0">
                  Comments
                </Form.Label>
                <div className="warranty-section">
                  {isWarranty && userDetails?.BillingCustomer && (
                    <>
                      <Tooltip
                        target=".dollar-icon"
                        content={`Credits will be charged to the requester's billing customer : ${userDetails.BillingCustomer}`}
                        position="top"
                        event="both"
                        className="billing-tooltip"
                      />

                      <FaFileInvoiceDollar
                        className="dollar-icon"
                        style={{ cursor: "pointer" }}
                      />
                    </>
                  )}
                  <label htmlFor="warranty" className="warranty-label">
                    Under Warranty
                  </label>
                  <>
                    {!userDetails?.BillingCustomer && <Tooltip
                      target=".warranty-wrapper"
                      content="Billing customer not available."
                      position="left"
                    />
                    }
                    <span className="warranty-wrapper">
                      <Checkbox
                        inputId="warranty"
                        checked={isWarranty}
                        disabled={!userDetails?.BillingCustomer}
                        onChange={(e) => setIsWarranty(e.checked)}
                        className="warranty-checkbox"
                      />
                    </span>
                  </>
                </div>
              </div>
              <Form.Control
                as="textarea"
                rows={5}
                onChange={(e) => populateCommentValue(e)}
                disabled={isDisabled}
                maxLength={1000}
                value={commentValue}
              />
            </Form.Group>
          </Dialog>
        }
      </div>
      <div className="detail-modal-wrapper">
        <Modal
          className="detail-modal"
          show={details}
          animation={true}
          backdrop={false}
          style={{ background: "#0000004d" }}
        >
          <Modal.Header>
            REQUEST DETAILS{" "}
            <CloseButton onClick={() => { setDetail(false); setRevokeWorkDetailsText(""); setWorkReportedComments(""); }}></CloseButton>
          </Modal.Header>
          <Modal.Body className="detail-body">
            {/* Title card */}
            <div className="detail-title-card">
              <div className="detail-request-title">
                {requestNumber} - {detailTitle}
              </div>
              {detailIsRevoked ? (
                <div className="revoked-badge">
                  <FaExclamationTriangle className="badge-icon" /> Request Revoked
                </div>
              ) : detailIsWorkReported ? (
                <div className="work-reported-badge">
                  <span className="badge-check">✓</span> Work Reported
                </div>
              ) : (
                <div className="approved-badge">
                  <span className="badge-check">✓</span> Access Request Approved
                </div>
              )}
            </div>

            {/* Info grid */}
            <div className="detail-info-grid">
              <div className="detail-info-item">
                <FaCalendarAlt className="detail-icon" />
                <div className="detail-info-content">
                  <div className="detail-info-label">Date</div>
                  <div className="detail-info-value">
                    {detailDateStart} - {detailDateEnd}
                  </div>
                </div>
              </div>
              <div className="detail-info-item">
                <FaNetworkWired className="detail-icon device-icon" />
                <div className="detail-info-content">
                  <div className="detail-info-label">Device</div>
                  <div className="detail-info-value device-value">
                    {detailEquipment}
                  </div>
                </div>
              </div>
              <div className="detail-info-item">
                <FaShip className="detail-icon" />
                <div className="detail-info-content">
                  <div className="detail-info-label">Vessel</div>
                  <div className="detail-info-value">{detailVessel}</div>
                </div>
              </div>
              <div className="detail-info-item">
                <FaIdCard className="detail-icon" />
                <div className="detail-info-content">
                  <div className="detail-info-label">YN Number</div>
                  <div className="detail-info-value">{detailYardNumber}</div>
                </div>
              </div>
            </div>

            {/* Email notification */}
            <div className="email">
              <FaInfoCircle className="info-icon blue"></FaInfoCircle>{" "}
              Email with remote access request details, has been sent
              successfully to the requestor for the Request:{" "}
              <b>{requestNumber}.</b>
            </div>
            {
              revokeWorkDetailsText && (
                <div className="email" style={{ marginTop: '15px' }}>
                  <FaExclamationTriangle className="info-icon warning"></FaExclamationTriangle>{" "}
                  {revokeWorkDetailsText}
                </div>
              )
            }
            {/* Workflow info */}
            {
              !revokeWorkDetailsText && !detailIsWorkReported && (
                <div className="next" style={{ marginTop: '15px' }}>
                  <FaInfoCircle className="info-icon blue"></FaInfoCircle>{" "}
                  <b>{currentWorkFlow}</b> has been Completed.
                </div>
              )
            }
            {
              detailIsWorkReported && (
                <div className="next" style={{ marginTop: '15px' }}>
                  <FaInfoCircle className="info-icon blue"></FaInfoCircle>{" "}
                  <b>{currentWorkFlow}</b> has been Completed with comments: {workReportedComments}
                </div>
              )
            }

            {/* <div className="next-workflow">
              <b>{newWorkFlow}</b> on this request is pending with {assigneeRole}.
            </div> */}
            {/* Report Work section */}
            {isWithinAccessWindow && (
              <div className="report-work-section">
                <div className="report-work-header">
                  <span>REPORT WORK</span>
                </div>
                <div className="report-work-body">
                  <p className="report-work-subtitle">
                    Please provide details of the work performed for this
                    request. Submitting this report will close the request.
                  </p>
                  <div className="work-details-label-row">
                    <label>
                      Work Details <span className="required">*</span>
                    </label>
                    <span className="char-count">
                      {workDetailsText.length}/250
                    </span>
                  </div>
                  <textarea
                    className="work-details-textarea"
                    placeholder="Enter details of the work performed, observations, actions taken, and any relevant notes..."
                    maxLength={250}
                    value={workDetailsText}
                    onChange={(e) => setWorkDetailsText(e.target.value)}
                  />
                  <div className="work-details-hint">
                    <FaInfoCircle className="info-icon blue" /> Minimum 10
                    characters required
                  </div>
                  <button
                    className="submit-report-btn"
                    disabled={workDetailsText.trim().length < 10}
                    onClick={() => {
                      handleDetailClose();
                    }}
                  >
                    <FaPaperPlane /> SUBMIT REPORT & CLOSE
                  </button>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </div>
      <Toast ref={toast} />
    </div>
  ) : (
    <div className="unauthorized">
      <div className="center-align">
        <p>
          You are not authorised to view this application. Please contact admin
          for access
        </p>
        <div className="link" onClick={userLogout}>
          Go to login
        </div>
      </div>
    </div>
  );
};

export default ServiceRequestList;
